import { vendor } from './vendor';
import { modules } from './app/modules';

let app = angular.module('spabooker', [
  ...vendor,
  ...modules,
])
  .config([ '$locationProvider', '$urlRouterProvider', function ($locationProvider, $urlRouterProvider) {
    $locationProvider.html5Mode(true);
    $urlRouterProvider.otherwise(function($injector) {
      var $state = $injector.get('$state');
      $state.go('404', {} , { location: false });
    });
  } ])
  .config([ 'uiSelectConfig', function (uiSelectConfig) {
    uiSelectConfig.theme = 'select2';
  } ])
  .factory('$exceptionHandler', [ '$window', '$log', function ($window, $log) {
    return function sentryException (exception, cause) {
      if ($window.Sentry
        && (typeof exception === 'string'
            || typeof exception === 'array')
          && !(exception.includes('Unauthenticated')
            || exception.includes('Unauthorized'))) {
        $window.Sentry.captureException(exception);
      }

      $log.warn(exception, cause);
    };
  } ])
  .config([ 'momentPickerProvider', momentPickerProvider => {
    momentPickerProvider.options({
      minutesStep: 30,
      minutesFormat: 'HH:mm:[00]'
    });
  } ])
  .run([ '$rootScope', '$location', function ($rootScope, $location) {
    if (typeof FS !== 'undefined') {
      let profile = JSON.parse(localStorage.getItem('profile'));
      if (profile) {
        FS.identify(profile.sub, {
          displayName: profile.name,
          role: profile['https://www.lobby.travel/role']
        });
      }
    }

    $rootScope.$on('$locationChangeSuccess', function () {
      if (typeof analytics !== 'undefined') {
        analytics.page();
      }

      let Url = $location.url();
      let urlParts = Url.split('/')
        .splice(1);
      let titleParts = [];

      if (Url.includes('#')) {
        titleParts = [];
      } else if (urlParts[0] === '') {
        titleParts.push('Dashboard');
      } else {
        for (let titlePart of urlParts) {
          titleParts.push(titlePart.charAt(0)
            .toUpperCase() + titlePart.slice(1));
        }
      }

      $rootScope.$watch('currentProperty', function () {
        $rootScope.pageTitle = titleParts.join(' > ');
        if ($rootScope.currentProperty) {
          $rootScope.pageTitle += ' (' + $rootScope.currentProperty.name + ')';
        }
      });
    });
  } ]);

export default app;



// WEBPACK FOOTER //
// ./frontend/admin/app.js